export function getHeroImage(items: string[], heroImageIndex?: number) {
  if (!Boolean(items.length)) {
    return require('assets/images/image-placeholder.png');
  }

  if (!heroImageIndex) return items[0];

  return items[heroImageIndex];
}
